import styled from "styled-components";

export default c => styled(c)`
  .paper-class {
    margin-top: 0.25px;
  }

  .password-fields,
  .permission-fields {
    padding: 0em 0.5em;
  }

  .allowed-companies-main-div {
    padding-right: 0.5em;
  }

  .allowed-companies {
    max-height: 11em;
    overflow-y: auto;
    padding: 0.5em 0em;
  }

  .label-class {
    width: 100%;
    font-family: Source Sans Pro;
    font-size: 1.1em;
    font-weight: bold;
    color: #222;
  }

  .allowed-companies-col {
    margin: 0.25em 0em;
  }

  .allowed-companies-slug {
    font-size: 1.025em;
    display: block;
  }

  .allowed-companies-cnpj {
    font-size: 0.9em;
    font-weight: 550;
    color: rgba(0, 0, 0, 0.54);
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/style.js